module.exports = __webpack_public_path__ + "static/logo-sticky-cdbd553b7d2812839e296e13a4523180.svg";